import styled, { css } from 'styled-components';
import ReactTooltip from 'react-tooltip';

export const RadioButtonGroup = styled.div`
display: flex;
flex-direction: column;
margin-bottom: ${({ thin }) => (thin ? '1em' : '2.2em')};
line-height: 1.5em;

> :not(:last-child) {
  margin-bottom: 1em;
}
`;

export const Required = styled.span`
color: red;
margin-left: 2px;
margin-right: 2px;
`;

export const RadioButtonRow = styled.div`
display: flex;
flex-direction: row;

@media only screen and (max-width: 1200px) {
  flex-direction: column;
}
`;

export const RadioButton = styled.label`

&, label {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 1.5em;
  white-space: nowrap;
  cursor: pointer;

  input {
    display: none;
  }
}
@media only screen and (max-width: 1200px) {
  margin-bottom: 0.5rem;
}
`;

export const RadioButtonCircle = styled.span`
display: block;
width: 20px;
height: 20px;
border-radius: 50%;
margin-right: .25em;

border: 1px solid gray;

${({ selected }) => (selected && css`
  width: 10px;
  height: 10px;
  border: 6px solid #417ca5;
`)}
`;

export const StyledTooltip = styled(ReactTooltip).attrs({
  place: 'top',
  type: 'light',
  effect: 'solid',
  multiline: true,
})`
-webkit-box-shadow: 10px 10px 25px 1px rgba(105,105,105,0.66);
-moz-box-shadow: 10px 10px 25px 1px rgba(105,105,105,0.66);
box-shadow: 10px 10px 25px 1px rgba(105,105,105,0.66);
text-align: left;
opacity: 1;
line-height: 1.3em;
`;
